import { Flex, type FlexProps, Text } from '@chakra-ui/react'

const CONFIG = {
  default: {
    height: '16px',
    width: '16px',
    widthWithValue: '20px',
    borderRadius: '20px',
    fontSize: '10px',
    top: '0px',
    right: '0px',
  },
  navbarworld: {
    height: '16px',
    width: '16px',
    widthWithValue: '20px',
    borderRadius: '20px',
    fontSize: '12px',
    top: '-1px',
    right: '-1px',
  },
  small: {
    height: '10px',
    width: '10px',
    widthWithValue: '14px',
    borderRadius: '10px',
    fontSize: '8px',
    top: '4px',
    right: '4px',
  },
  large: {
    height: '20px',
    width: '20px',
    widthWithValue: '24px',
    borderRadius: '24px',
    fontSize: '12px',
    top: '4px',
    right: '4px',
  },
}

type NotificationBubbleVariant = keyof typeof CONFIG

export default function NotificationBubble({
  value = null,
  variant = 'default',
  position = 'absolute',
}: {
  value?: number | null
  variant?: NotificationBubbleVariant
  position?: FlexProps['position']
}): JSX.Element | null {
  const { height, width, widthWithValue, top, right, borderRadius, fontSize } = CONFIG[variant]

  return (
    <Flex
      bgColor="primary.solid"
      position={position}
      align="center"
      justify="center"
      top={top}
      right={right}
      width={value != null ? widthWithValue : width}
      height={height}
      borderRadius={borderRadius}
      flexDirection="row"
      textAlign="center"
      border="2px solid"
      borderColor="primary.contrast"
    >
      {value != null ? (
        <Text as="span" fontSize={fontSize} color="primary.contrast">
          {value}
        </Text>
      ) : null}
    </Flex>
  )
}
